import { UPLOAD_RETURNS_IMAGE, DELETE_RETURNS_IMAGE } from '../../constants/endpoints';

export const PHOTO_UPLOAD_RECEIVE_IS_UPLOADING = 'PHOTO_UPLOAD_RECEIVE_IS_UPLOADING';
export const PHOTO_UPLOAD_RECEIVE_UPLOAD_ERROR_MSG = 'PHOTO_UPLOAD_RECEIVE_UPLOAD_ERROR_MSG';
export const PHOTO_UPLOAD_RECEIVE_NEW_IMAGES = 'PHOTO_UPLOAD_RECEIVE_NEW_IMAGES';
export const PHOTO_UPLOAD_DELETE_IMAGE = 'PHOTO_UPLOAD_DELETE_IMAGE';
export const PHOTO_UPLOAD_RESET_STATE = 'PHOTO_UPLOAD_RESET_STATE';

export const receiveIsUploading = (isUploading) => ({
  type: PHOTO_UPLOAD_RECEIVE_IS_UPLOADING,
  data: {
    isUploading,
  },
});

export const receiveUploadErrorMsg = (errorMsg) => ({
  type: PHOTO_UPLOAD_RECEIVE_UPLOAD_ERROR_MSG,
  data: {
    errorMsg,
  },
});

export const receiveImages = (images) => ({
  type: PHOTO_UPLOAD_RECEIVE_NEW_IMAGES,
  data: {
    images,
  },
});

export const resetPhotoUploadState = () => ({
  type: PHOTO_UPLOAD_RESET_STATE,
});

export const deleteImage = (filename) => (dispatch, getState) => {
  const {
    page: { browserFingerprint },
  } = getState();

  fetch(DELETE_RETURNS_IMAGE(filename), {
    method: 'DELETE',
    headers: {
      'narvar-tfid': browserFingerprint,
    },
  });

  dispatch({
    type: PHOTO_UPLOAD_DELETE_IMAGE,
    data: {
      filename,
    },
  });
};

export const uploadImages = (files) => async (dispatch, getState) => {
  const {
    page: { browserFingerprint },
  } = getState();

  const formData = new FormData();
  files.forEach((file) => formData.append('file', file));

  try {
    dispatch(receiveIsUploading(true));
    const response = await fetch(UPLOAD_RETURNS_IMAGE, {
      method: 'POST',
      body: formData,
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    });
    const uploadedImages = await response.json();
    dispatch(receiveImages(uploadedImages));
    dispatch(receiveIsUploading(false));
  } catch (error) {
    dispatch(receiveIsUploading(false));
  }
};

export const deleteCachedImages = () => (dispatch, getState) => {
  const {
    photoUpload: { images },
    page: { browserFingerprint },
  } = getState();

  images.forEach(({ filename }) =>
    fetch(DELETE_RETURNS_IMAGE(filename), {
      method: 'DELETE',
      headers: {
        'narvar-tfid': browserFingerprint,
      },
    }),
  );

  dispatch(resetPhotoUploadState());
};
